import {
  DeductionItem,
  DeductionItemType,
} from "@/models/deduction-items.model";
import apiClient from "./apiClient";

export async function getDeductionItems(args: {
  userId: number;
  month: number;
  year: number;
}): Promise<DeductionItem[]> {
  const { userId, month, year } = args;
  const res = await apiClient.get(
    `/users/${userId}/deduction-items?month=${month}&year=${year}`
  );
  const data: DeductionItem[] = res.data as DeductionItem[];
  return data;
}

export async function addHocItem(args: {
  amount: number;
  type: DeductionItemType;
  payslipId?: number;
  userId?: number;
  month?: number;
  year?: number;
}): Promise<DeductionItem> {
  const res = await apiClient.post("/deduction-items", {
    ...args,
  });
  const data: DeductionItem = res.data as DeductionItem;
  return data;
}

export async function deleteDeductionItem(id: number): Promise<boolean> {
  const res = await apiClient.delete(`/deduction-items/${id}`);
  return res.data as boolean;
}
